import React from "react";
import { SUBSTACK_URL } from "../../mock/mock";

const Footer = () => {
  return (
    <footer className="bg-[#FFFDF6] border-t border-[#41232E]/12 py-16 md:py-20">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid md:grid-cols-12 gap-10 mb-14">
          <div className="md:col-span-6">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-2.5 h-2.5 rounded-full bg-[#605F26]"></span>
              <span className="font-serif-display text-[#41232E] text-xl tracking-tight">
                The Owner&rsquo;s Mind
              </span>
            </div>
            <p className="font-serif-display italic text-[#41232E]/80 text-2xl md:text-3xl max-w-lg leading-snug">
              Ownership creates options. Options create choice. Choice creates freedom.
            </p>
          </div>

          <div className="md:col-span-2">
            <div className="uppercase tracking-[0.24em] text-[0.7rem] text-[#605F26] mb-4">
              Explore
            </div>
            <ul className="space-y-2.5 text-[#41232E]/80">
              <li><a href="#ideas" className="om-link">Ideas</a></li>
              <li><a href="#about" className="om-link">About</a></li>
              <li><a href="#gift" className="om-link">The Owner&rsquo;s Gift</a></li>
              <li><a href="#faq" className="om-link">FAQ</a></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="uppercase tracking-[0.24em] text-[0.7rem] text-[#605F26] mb-4">
              Follow
            </div>
            <ul className="space-y-2.5 text-[#41232E]/80">
              <li><a href={SUBSTACK_URL} target="_blank" rel="noreferrer" className="om-link">Substack</a></li>
              <li><a href="#" className="om-link">Instagram</a></li>
              <li><a href="#" className="om-link">LinkedIn</a></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="uppercase tracking-[0.24em] text-[0.7rem] text-[#605F26] mb-4">
              Contact
            </div>
            <ul className="space-y-2.5 text-[#41232E]/80">
              <li><a href="mailto:hello@theownersmind.com" className="om-link">hello@theownersmind.com</a></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-[#41232E]/12 pt-8 flex flex-col md:flex-row justify-between gap-4 text-xs text-[#41232E]/55 tracking-wide">
          <div>&copy; {new Date().getFullYear()} The Owner&rsquo;s Mind. All rights reserved.</div>
          <div className="flex gap-6">
            <a href="#" className="om-link">Privacy</a>
            <a href="#" className="om-link">Terms</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
